/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tracked/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxReadOnly from 'DesignSystem/TysiaCheckboxReadOnly/index'
import TysiaListColumn from 'DesignSystem/TysiaList/TysiaListColumn/index'



/** @type {import('Simple/types.js').View} */
export default function Tracked({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsList/Item/Tracked"
  
}) {
let txCardFieldDefinitionTrackedValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'tracked',
})
  return (<React.Fragment
>
<TysiaListColumn
  viewPath={`${viewPath}/TysiaListColumn`}
>
{childProps => (
<TysiaCheckboxReadOnly
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxReadOnly`}
 data="tx_card_field_definition.tracked"
 value={txCardFieldDefinitionTrackedValueData}
/>
)}
</TysiaListColumn>
{children}
</React.Fragment>)
}